<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
      {{ data.isEdit ? 'Edit' : 'Add' }} Site Downtime Entry {{text}}
    </div>
    <button mat-icon-button class="close-btn" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="mat-typography">
    <div>
      <table style="text-align:center; margin: 0 auto;">
        <tr>
          <td style="text-align: left;"><b>Name:</b></td>
          <td style="text-align: left;">{{data.userName}}</td>
        </tr>
        <tr>
          <td style="text-align: left;"><b>Date Captured:</b></td>
          <td>
            <mat-form-field appearance="outline">
              <input matInput [matDatepicker]="picker" [(ngModel)]="data.dateCaptured" #dcctrl="ngModel" required (dateChange)="onDateCapturedChange($event.value)"
                [disabled]="data.isEdit" placeholder="Choose a date" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="dcctrl.invalid"></mat-error>
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td style="text-align: left;"><b>Site Name:</b></td>
          <td style="text-align: left;">{{data.siteName}}</td>
        </tr>
      </table>
    </div>
    <form [formGroup]="sdcForm">
        <div class="tabsHeight">  
            <!-- ORA Downtime Section -->
            <div class="">
                <!-- <p style="font-style:italic;color: black;text-align: left;">
                    <b> If previous day gas production is under proforma, please select and assign a ranking from the following selections</b>
                </p>
                <br />
                <p style="color: black;text-align: left;">
                    Previous day's Gas Production: <b id="prevGas"> {{ previousDayGasProduction() }}</b>
                </p> -->
                <div class="form-container">
                    @for (category of equipmentCategories(); track category.id) {
                        <mat-form-field appearance="outline">
                            <mat-label>{{ getCategoryLabel(category) }}</mat-label>
                            <mat-select multiple [value]="getSelectedIdsForType(category.id.toString())"
                                (selectionChange)="onEquipmentSelectionChange(category.id.toString(), $event.value)">
                                <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                                <input #siteSearchInput matInput placeholder="Search ..." (input)="filterequipment($event, category.id.toString())"
                                    class="mat-select-search-input" aria-label="Search " (click)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation();" />
                                <mat-icon class="mat-select-search-icon">search</mat-icon>
                                </div>
                                @for (item of filteredEquipmentGroups()[category.id.toString()] || []; track item.id) {
                                    <mat-option [value]="item.id">
                                        {{ item.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
            </div>
            <div>
                @if (selectedEquipment().length > 0) {
                    <div style="margin-left: 20px;">
                        <table class="sequence-table mat-elevation-z2">
                            <thead>
                                <tr>
                                    <th>Process</th>
                                    <th>Selected<br />Equipment</th>
                                    <th>Downtime in minutes</th>
                                    <th>Impact</th>
                                    <th>Trigger</th>
                                    <th>Comments</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (sel of selectedEquipment(); track sel.equipmentId) {
                                    <tr>
                                        <td>{{ getProcessNameForSelection(sel) }}</td>
                                        <td>{{ equipmentLabelMap.get(sel.equipmentId) ?? 'Unknown' }}</td>
                                        <td>
                                            <mat-form-field appearance="outline" class="sequence-input-field"
                                                [class.mat-form-field-invalid]="attemptedSave() && sel.minutes == null">
                                                <input matInput type="text" min="0" max="100" [value]="sel.minutes ?? ''"
                                                    (input)="onMinutesInput(sel.equipmentId, $event)"
                                                    placeholder="minutes" (keypress)="onlyIntegers($event)"  required/>
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field appearance="outline" class="impact-input-field"
                                                [class.mat-form-field-invalid]="attemptedSave() && (sel.impactId == null || sel.impactId <= 0)">
                                              <mat-label>Impact Type</mat-label>
                                              <mat-select [value]="sel.impactId" required
                                                  (selectionChange)="onImpactChange(sel.equipmentId, $event.value)">
                                                @for (it of impactTypes; track it.id) {
                                                  <mat-option [value]="it.id">{{ it.name }}</mat-option>
                                                }
                                              </mat-select>
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field appearance="outline" class="trigger-input-field">
                                                <mat-label>Trigger</mat-label>
                                                <mat-select [value]="sel.triggerId" [disabled]="controlPermissions.trigger"
                                                    (selectionChange)="onTriggerChange(sel.equipmentId, $event.value)">
                                                    @for (trigger of triggerTypes; track trigger.id) {
                                                        <mat-option [value]="trigger.id">{{ trigger.name }}</mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </td>
                                        <td>                                            
                                            <mat-form-field appearance="outline" class="comments-input-field">
                                                <mat-label>Comments</mat-label>
                                                <textarea matInput cdkTextareaAutosize [cdkAutosizeMinRows]="1"
                                                    [value]="sel.comments ?? ''" (input)="onCommentsChange(sel.equipmentId, $event)"></textarea>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onCancel()">Cancel</button>
    @if(canShowSaveButton()) {
      <button mat-raised-button color="primary" (click)="onSave()">Save</button>
    }
  </mat-dialog-actions>
  
